"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ShopUpsell_1 = require("../../ShopV2/ShopUpsell");
var shopV2_1 = require("../../../utils/shopify/shopV2");
var shop_data_1 = require("../../../utils/shopify-graphql/shop-data");
var ga_1 = require("../../../utils/ga");
var ShopUpsellDoubleWrapper = function (_a) {
    var addOn = _a.addOn, bundleUpsell = _a.bundleUpsell;
    var _b = (0, hooks_1.useState)('addOn'), activeOption = _b[0], setActiveOption = _b[1];
    var handleAddToCart = function (prod) { return __awaiter(void 0, void 0, void 0, function () {
        var product, variant, variantId, sellingPlan, upsellProductData, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, (0, shop_data_1.getShopProductData)(prod.handle)];
                case 1:
                    product = _b.sent();
                    variant = product === null || product === void 0 ? void 0 : product.variants.nodes[0];
                    if (!(product && variant)) return [3 /*break*/, 3];
                    variantId = variant.id.split('/')[4];
                    sellingPlan = (_a = variant.sellingPlanAllocations.nodes[0]) === null || _a === void 0 ? void 0 : _a.sellingPlan.id.split('/')[4];
                    upsellProductData = [
                        {
                            id: variantId,
                            quantity: 1,
                            selling_plan: sellingPlan,
                        },
                    ];
                    return [4 /*yield*/, (0, shopV2_1.addToCart)({ items: upsellProductData })];
                case 2:
                    _b.sent();
                    document.dispatchEvent(new Event('fetchAndSlideCart'));
                    (0, ga_1.sendAddToCartEventFromShop)(product, variant);
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error('Failed to add upsell to cart:', error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // A/B: S587 - Section 4 Bundle Upsell test
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "shop-selector shop-selector--section-4-test" },
            (0, preact_1.h)("div", { className: "shop-selector__button-group" },
                (0, preact_1.h)("span", { className: "shop-selector__button addOn ".concat(activeOption === 'addOn' ? 'active' : ''), onClick: function () { return setActiveOption('addOn'); } }, "Add On"),
                (0, preact_1.h)("span", { className: "shop-selector__button saveBundles ".concat(activeOption === 'saveBundles' ? 'active' : ''), onClick: function () { return setActiveOption('saveBundles'); } }, "Save with Bundles")),
            (0, preact_1.h)("div", { className: "shop-selector__bar" },
                (0, preact_1.h)("div", { className: "shop-selector__indicator ".concat(activeOption) })),
            activeOption === 'addOn' &&
                addOn.map(function (upsell) { return ((0, preact_1.h)("div", { key: upsell.handle, class: "shop-selector__input-box shop__selection--section-4-test" },
                    (0, preact_1.h)(ShopUpsell_1.default, { handleAddToCart: handleAddToCart, upsell: upsell }))); }),
            activeOption === 'saveBundles' &&
                bundleUpsell.map(function (upsell) { return ((0, preact_1.h)("div", { key: upsell.handle, class: "shop-selector__input-box shop__selection--section-4-test" },
                    (0, preact_1.h)(ShopUpsell_1.default, { handleAddToCart: handleAddToCart, upsell: upsell }))); }))));
};
exports.default = ShopUpsellDoubleWrapper;
